import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Popover from 'ui-library/floating-ui/Popover';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export default function FinalizedMessage(): JSX.Element {
  return (
    <Popover
      renderContent={() => <span>The sticky end bases are from the sequence when it was finalized.</span>}
    >
      <BenchlingIcon className={css(styles.icon)} icon="info-circle" />
    </Popover>
  );
}

const styles = StyleSheet.create({
  icon: {
    marginLeft: '5px',
  },
});
